import apiClient from '../../api/http-common';

const getProfileOptions = () =>
  apiClient.post('/profile/get-options-data')

const updateProfile = () =>
  apiClient.post('/profile/get-options-data')

const editProfileData = () =>
  apiClient.post('/profile/edit')

const getFileProfile = () =>
  apiClient.post('/profile/get-file')

const getNotificationCount = () =>
  apiClient.post('/notifications/count-new')

const getNewNotifications = () =>
  apiClient.post('/notifications/get-new')

const getNotifications = (data) =>
  apiClient.post('/notifications/index', data)

const updateProfileData = (data) =>
  apiClient.post('/profile/update', data)

const ProfileService = {
  getProfileOptions,
  updateProfile,
  editProfileData,
  getFileProfile,
  updateProfileData,
  getNotificationCount,
  getNotifications,
  getNewNotifications
};

export default ProfileService;
